"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTypeValues = void 0;
exports.UserTypeValues = ['Normal', 'Service'];
